<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <!-- Hero banner -->
        <div class="card bg-gradient-primary overflow-hidden mb-4">
          <div class="card-body position-relative py-4">
            <span class="hero-glow"></span>
            <div class="row align-items-center position-relative">
              <div class="col-auto">
                <div class="icon icon-shape icon-lg bg-white shadow text-center border-radius-lg">
                  <i class="ni ni-check-bold text-dark opacity-10" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col">
                <h5 class="text-white mb-0">Setting Approval</h5>
                <p class="text-white text-sm opacity-8 mb-0">
                  Atur siapa yang menjadi approver untuk setiap pengajuan karyawan (cuti, izin, lembur, dsb). Cukup cari nama karyawan, tanpa perlu tahu ID-nya.
                </p>
              </div>
            </div>

            <div class="row mt-4 position-relative">
              <div class="col-6 col-md-4">
                <div class="hero-stat">
                  <span class="hero-stat-label">Total Setting</span>
                  <span class="hero-stat-value">{{ table.data.length }}</span>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="hero-stat">
                  <span class="hero-stat-label">Requestor Terdaftar</span>
                  <span class="hero-stat-value">{{ uniqueRequesterCount }}</span>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="hero-stat">
                  <span class="hero-stat-label">Approver Terdaftar</span>
                  <span class="hero-stat-value">{{ uniqueApproverCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="row align-items-center pt-4 px-3">
            <div class="col-12 col-md-4">
              <div class="card-header pb-0">
                <h6 class="mb-0">Daftar Setting Approval</h6>
                <p class="text-xs text-secondary mb-0">Klik ikon edit untuk mengubah requestor / approver.</p>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center">
              <div class="search-wrapper mx-auto mt-3 mt-md-0">
                <i class="fa fa-search search-icon" aria-hidden="true"></i>
                <input
                  type="text"
                  class="form-control search-input"
                  placeholder="Cari nama requestor..."
                  v-model="search.nama_requester"
                  @input="get()"
                >
              </div>
            </div>
            <div class="col-12 col-md-4 text-end pe-4">
              <argon-button
                class="mt-3 mt-md-0"
                variant="gradient"
                color="warning"
                size="sm"
                @click="modalImport()"
              ><i class="fa fa-upload fa-sm" aria-hidden="true"></i> Import</argon-button>
              <argon-button
                class="mt-3 mt-md-0"
                style="margin-left: 8px;"
                variant="gradient"
                color="success"
                size="sm"
                @click="create()"
              ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0 scroll">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="background-color: #F0F8FF;">
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder ps-3">Requestor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Approval To</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Approver</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="ps-3">
                      <div class="d-flex align-items-center py-1">
                        <div class="avatar-initial" :style="{ backgroundColor: avatarColor(row.nama_requester) }">{{ initials(row.nama_requester) }}</div>
                        <div class="ms-2">
                          <h6 class="mb-0 text-sm">{{ row.nama_requester }}</h6>
                          <span class="text-secondary text-xs">ID: {{ row.id_karyawan_requester }}</span>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm bg-gradient-success"><i class="fa fa-arrow-right" aria-hidden="true"></i></span>
                    </td>
                    <td>
                      <div class="d-flex align-items-center py-1">
                        <div class="avatar-initial" :style="{ backgroundColor: avatarColor(row.nama_approver) }">{{ initials(row.nama_approver) }}</div>
                        <div class="ms-2">
                          <h6 class="mb-0 text-sm">{{ row.nama_approver }}</h6>
                          <span class="text-secondary text-xs">ID: {{ row.id_karyawan_approver }}</span>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <button class="btn btn-link text-secondary mb-0 px-2" title="Edit" @click="edit(row.id)">
                        <i class="fas fa-edit fa-sm" aria-hidden="true"></i>
                      </button>
                      <button class="btn btn-link text-danger mb-0 px-2" title="Hapus" @click="remove(row.id)">
                        <i class="fas fa-trash fa-sm" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="table.data.length === 0">
                    <td colspan="4" class="text-center text-sm text-secondary py-5">
                      <i class="fa fa-check-circle fa-2x mb-2" aria-hidden="true" style="opacity: 0.4;"></i>
                      <br>Belum ada setting approval
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD / EDIT DATA ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{form.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label class="form-control-label mt-3">REQUESTOR <span style="color: red;">*</span></label>
        <karyawan-search-select
          v-model="setting.id_karyawan_requester"
          :label="setting.requesterLabel"
          placeholder="Ketik nama requestor..."
        />
        <label class="form-control-label mt-3">APPROVER <span style="color: red;">*</span></label>
        <karyawan-search-select
          v-model="setting.id_karyawan_approver"
          :label="setting.approverLabel"
          placeholder="Ketik nama approver..."
        />
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6">
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="form.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()">Save</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL IMPORT ======= -->
  <div class="container">
    <vue-final-modal v-model="formImport.show" classes="modal-container" content-class="modal-content" :z-index="10000">
    <!-- header -->
    <div class="row">
      <div class="col-11 float-left">
        <span class="modal__title">{{formImport.title}}</span>
      </div>
      <div class="col-1 float-right">
        <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formImport.show = false"></i>
      </div>
    </div><hr>
    <!-- end header -->
    <div class="modal__content container">
      <div>
        <label for="example-text-input" class="form-control-label mt-3">Upload File <span style="color: red;">*</span></label>
        <input type="file" class="form-control" placeholder="Upload File" @change="filesChange" style="margin-bottom: 20px;">
        <small>Download Template<a :href="storageUrl+'/template_import/Template Import Data Setting Approval.xlsx'" style="color: blue;"> Import Data Setting Approval</a></small>
        <div class="mt-2" v-if="tabelError.data.length !== 0 ">
          <table>
            <thead>
              <slot name="columns">
                <tr style="background-color: #F0F8FF;">
                  <th style="font-size: 13px; text-align: center;">Column</th>
                  <th style="font-size: 13px; text-align: center;">Error</th>
                  <th style="font-size: 13px; text-align: center;">Row</th>
                  <th style="font-size: 13px; text-align: center;">Values</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tabelError.data" :key="i">
                <td style="font-size: 13px; text-align: center;">{{ row.attribute }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.errors }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.row }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.values }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="row float-right mt-5">
      <div class="col-6">
      </div>
      <div class="col-2" style="margin-right: 20px;">
        <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formImport.show = false">Close</argon-button>
      </div>
      <div class="col-1">
        <button type="primary" class="btn btn-sm btn-info btn-fill" @click="importData()" :disabled="onLoading">
          <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
          <span v-else>
              <span>Import</span>
          </span>
        </button>
      </div>
    </div>
    <!-- end footer -->
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import settingApproval from '@/services/settingApproval.service';
import akun from '@/services/akun.service';
import KaryawanSearchSelect from '@/components/KaryawanSearchSelect.vue';

const AVATAR_COLORS = ['#C8102E', '#2563EB', '#0D9488', '#9333EA', '#F59E0B', '#16A34A'];

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    'karyawan-search-select': KaryawanSearchSelect,
  },
  data() {
    return {
      table: {
        data: []
      },
      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      formImport: {
        add: true,
        title: "Import Data Setting Approval",
        show: false
      },
      dataImport: '',
      onLoading: false,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      setting: {},
      search: {
        nama_requester: '',
      },
      apiUrl :config.apiUrl,
      role: '',
    };
  },
  computed: {
    uniqueRequesterCount() {
      return new Set(this.table.data.map(function(r) { return r.id_karyawan_requester; })).size;
    },
    uniqueApproverCount() {
      return new Set(this.table.data.map(function(r) { return r.id_karyawan_approver; })).size;
    },
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
    this.getRole();
  },
  methods: {
    initials(nama) {
      if (!nama) return '?';
      const parts = nama.trim().split(' ');
      return parts.length > 1 ? (parts[0][0] + parts[1][0]).toUpperCase() : parts[0].substring(0, 2).toUpperCase();
    },
    avatarColor(nama) {
      if (!nama) return AVATAR_COLORS[0];
      let hash = 0;
      for (let i = 0; i < nama.length; i++) {
        hash = nama.charCodeAt(i) + ((hash << 5) - hash);
      }
      return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
    },
    get(){
      let context = this;
      Api(context, settingApproval.index({nama_requester: context.search.nama_requester})).onSuccess(function(response) {
          context.table.data = response.data.data.data;
      }).onError(function(error) {
          if (error.response.status == 404) {
              context.table.data = [];
          }
      })
      .call()
    },
    getRole(){
      let context = this;
      context.onLoading = true;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
          context.role = response.data.data[0].role;
          if (response.data.data[0].role != 'Admin') {
            context.$router.push({ path: '/detail-profile/'+response.data.data[0].employee_id})
          }
      }).onError(function() {
      })
      .call()
    },
    create() {
      this.form.add   = true;
      this.form.show  = true;
      this.form.title = "Add Data";
      this.setting    = {};
    },
    edit(id) {
      let context = this;
      Api(context, settingApproval.show(id)).onSuccess(function(response) {
          context.setting = {
            id: response.data.data.id,
            id_karyawan_requester: String(response.data.data.id_karyawan_requester),
            requesterLabel: response.data.data.nama_requester,
            id_karyawan_approver: String(response.data.data.id_karyawan_approver),
            approverLabel: response.data.data.nama_approver,
          };
          context.form.show  = true;
          context.form.title = 'Edit Data';
      })
      .call()
    },
    save(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.setting.id_karyawan_requester && context.setting.id_karyawan_approver) {
        formData.append('id_karyawan_requester', context.setting.id_karyawan_requester);
        formData.append('id_karyawan_approver', context.setting.id_karyawan_approver);
      }else{
        return alert('Requestor dan Approver Wajib Dipilih dari Pencarian')
      }

      if (context.form.title == 'Add Data') {
          api = Api(context, settingApproval.create(formData));
      } else {
          api = Api(context, settingApproval.update(context.setting.id, formData));
      }
      api.onSuccess(function() {
        context.get();
        context.form.show = false;
        context.notify((context.form.title == 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function() {
        context.notify((context.form.title == 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')
      })
      .call();
    },
    remove(id) {
      var r = confirm("Anda yakin ingin menghapus data ini ?");
      if (r == true) {
        let context = this;

        Api(context, settingApproval.delete(id)).onSuccess(function() {
            context.get();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    modalImport(){
      this.formImport.show  = true;
      this.formImport.title = "Import Data Setting Approval";
      this.tabelError.data  = [];
    },
    filesChange(e) {
        this.dataImport = e.target.files[0];
    },
    importData(){
      let api = null;
      let context = this;
      let formData = new FormData();
      this.onLoading = true;

      if (this.dataImport != undefined) {
        formData.append('import_data', this.dataImport);
      }else{
        return alert('File Import Not Found')
      }

      api = Api(context, settingApproval.import(formData));
      api.onSuccess(function() {
          context.onLoading = false;
          context.get();
          context.formImport.show = false;
          context.notify('Import Data Success', 'success')
      }).onError(function(error) {
          context.tabelError.data = error.response.data.data;
          context.notify('Import Data Failed', 'error')
          context.onLoading = false;
      })
      .call();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          autoClose: 2000,
        });
      }else{
        toast.error(message, {
          autoClose: 2000,
        });
      }
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.hero-glow {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 70%);
  pointer-events: none;
}
.hero-stat {
  display: flex;
  flex-direction: column;
  background: rgba(255,255,255,0.08);
  border-radius: 0.75rem;
  padding: 10px 12px;
  margin-bottom: 8px;
}
.hero-stat-label {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(255,255,255,0.7);
}
.hero-stat-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: #fff;
}
.search-wrapper {
  position: relative;
  max-width: 320px;
}
.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #8392AB;
  font-size: 0.8rem;
}
.search-input {
  padding-left: 36px;
  border-radius: 999px;
}
.avatar-initial {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 10px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.scroll {
  overflow: auto;
  height: 500px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
